import React, { useState } from "react";
import styles from "./ArtistCard.module.scss";
import artistImage from "../../../assets/images/artist-image.jpg";
import FollowIcon from "components/svgs/FollowIcon";
import SupportIcon from "components/svgs/SupportIcon";
import { useNavigate } from "react-router-dom";
import artworkImage from "../../../assets/images/card-image.jpg";
import sculptureImage from "../../../assets/images/sculpture-image.jpg";

const ArtistCard = ({ type, showArtworks }) => {
  const navigate = useNavigate();
  const [following, setFollowing] = useState(false);

  return (
    <div className={styles.card} onClick={() => console.log("Card clicked.")}>
      <div className={styles.cardImage}>
        <img src={artistImage} alt={"Name Lastname Fathername"} />
      </div>
      {showArtworks ? (
        <div className={styles.artworksContainer}>
          <div>
            <img
              src={type === "painter" ? artworkImage : sculptureImage}
              alt="Artwork Name"
            />
          </div>
          <div>
            <img
              src={type === "painter" ? artworkImage : sculptureImage}
              alt="Artwork Name"
            />
          </div>
          <div>
            <img
              src={type === "painter" ? artworkImage : sculptureImage}
              alt="Artwork Name"
            />
          </div>
        </div>
      ) : null}
      <div className={styles.cardBody}>
        <div
          className={styles.cardArtistFullName}
          title={"Name Lastname Fathername"}
          onClick={() => navigate(`/artist/1`)}
        >
          Name Lastname Fathername
        </div>
        <div className={styles.cardArtworksCount} title={"26 Artworks"}>
          26 Artworks
        </div>
        <div
          className={`${styles.cardFooter} ${
            following ? styles.following : ""
          }`}
          onClick={(e) => {
            e.stopPropagation();
            setFollowing(!following);
          }}
        >
          {!following ? <FollowIcon /> : null}
          <span>{!following ? "Follow The Artist" : "Following"}</span>
        </div>
        <div className={styles.cardFooter}>
          <SupportIcon />
          <span>Support The Artist</span>
        </div>
      </div>
    </div>
  );
};

export default ArtistCard;
